import { FC } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Navbar from './components/Navbar';
import Systems from './pages/Systems';
import Users from './pages/Users';
import Incidents from './pages/Incidents';
import Subscriptions from './pages/Subscriptions';
import './App.css';
import SystemDetails from './pages/SystemDetails';
import IncidentDetails from './pages/IncidentDetails';
import Alerts from './pages/Alerts';
import Login from './pages/Login';
import ProtectedRoute from './components/ProtectedRoute';
import { useAuth } from './hooks/useAuth';
import Acknowledge from './pages/Acknowledge';
import UserDetails from './pages/UserDetails';

const App: FC = () => {
  const { isLoggedIn, user, isLoading, login, logout } = useAuth();

  if (isLoading) {
    return <div>Loading...</div>;
  }

  return (
    <Router>
      {isLoggedIn && (
        <Navbar isLoggedIn={isLoggedIn} onLogout={logout} user={user} />
      )}
      <div className="container mt-4">
        <Routes>
          <Route path="login" element={<Login onLogin={login} />} />

          {/* Protected Routes */}
          <Route
            path="/"
            element={
              <ProtectedRoute isLoggedIn={isLoggedIn}>
                <Incidents />
              </ProtectedRoute>
            }
          />
          <Route
            path="systems"
            element={
              <ProtectedRoute isLoggedIn={isLoggedIn}>
                <Systems />
              </ProtectedRoute>
            }
          />
          <Route
            path="systems/:id"
            element={
              <ProtectedRoute isLoggedIn={isLoggedIn}>
                <SystemDetails />
              </ProtectedRoute>
            }
          />
          <Route
            path="users"
            element={
              <ProtectedRoute isLoggedIn={isLoggedIn}>
                <Users />
              </ProtectedRoute>
            }
          />
          <Route
            path="users/:id"
            element={
              <ProtectedRoute isLoggedIn={isLoggedIn}>
                <UserDetails />
              </ProtectedRoute>
            }
          />
          <Route
            path="subscriptions"
            element={
              <ProtectedRoute isLoggedIn={isLoggedIn}>
                <Subscriptions />
              </ProtectedRoute>
            }
          />
          <Route
            path="incidents"
            element={
              <ProtectedRoute isLoggedIn={isLoggedIn}>
                <Incidents />
              </ProtectedRoute>
            }
          />
          <Route
            path="incidents/:id"
            element={
              <ProtectedRoute isLoggedIn={isLoggedIn}>
                <IncidentDetails />
              </ProtectedRoute>
            }
          />
          <Route
            path="alerts"
            element={
              <ProtectedRoute isLoggedIn={isLoggedIn}>
                <Alerts />
              </ProtectedRoute>
            }
          />
          <Route
            path="incidents/:id/acknowledge"
            element={
              <ProtectedRoute isLoggedIn={isLoggedIn}>
                <Acknowledge />
              </ProtectedRoute>
            }
          />
          {/* Handle unknown routes */}
          {/* <Route path="*" element={<NotFound />} /> */}
        </Routes>
      </div>
    </Router>
  );
};

export default App;
